function BoardPlaceholder() {
  return (
    <div className="container" style={{ marginTop: "5rem" }}>
      <div className="fs-3">Loading Sprint details, please wait!</div>
      <div
        style={{
          height: "35rem",
        }}
        className="row placeholder-glow"
      >
        <div
          style={{ borderRight: "10px solid white" }}
          className="placeholder fs-5 col-sm-3"
        >
          To Do
        </div>
        <div
          style={{ borderRight: "10px solid white" }}
          className="placeholder fs-5 col-sm-3"
        >
          In Progress
        </div>
        <div
          style={{ borderRight: "10px solid white" }}
          className="placeholder fs-5 col-sm-3"
        >
          Verify
        </div>
        <div
          style={{ borderRight: "10px solid white" }}
          className="placeholder fs-5 col-sm-3"
        >
          Done
        </div>
      </div>
    </div>
  );
}

export default BoardPlaceholder;
